const $win = $(window);
const $doc = $(document);


$doc.on('change', '.js-select-redirect', function(){
  const $this = $(this);

  window.location = $this.val();
})